<template>
  <div id="details" :class="$mq" @click.self="close()">
    <div class="modal" :class="$mq">
      <div class="close" @click="close()">x</div>
      <div class="title">
        <SvgIcon class="icon" :icon="`product-${range.name}`" fill></SvgIcon>
        {{ range.name }}
      </div>
      <div class="price">
        <div class="inline center">
          <span class="amount">{{ range.amounts[annualAmount] | toCurrency }}</span>
          <span>
            {{ $t(`simulation.product.${amountType}`) }}
            <br />
            {{ $t("simulation.product.annualy") }}
          </span>
        </div>
        <div class="inline center">
          <span class="amount second">{{ range.amounts[monthlyAmount] | toCurrency }}</span>
          <span>
            {{ $t(`simulation.product.${amountType}`) }}
            <br />
            {{ $t("simulation.product.monthly") }}
          </span>
        </div>
      </div>
      <div class="inline space-around top">
        <div class="product" :class="$mq" v-if="hasElec">
          <div class="price-details">
            <div class="inline center">
              <SvgIcon icon="elec" class="icon" fill></SvgIcon>
              <h3>{{ $t('simulation.product.detail.megaElec') }}</h3>
            </div>
            <table class="price inline">
              <tr class="inline h-item-margin">
                <th class="grow txt-left"></th>
                <th>{{ $t('unity.centKWh') }}</th>
                <th>{{ $t('unity.annual') }}</th>
              </tr>
              <tr class="inline">
                <td class="grow txt-left">{{$t('simulation.product.detail.subscription')}}</td>
                <td>{{ range.electricity.subscription[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline" v-if="range.electricity.subtotal.discount">
                <td class="grow txt-left">{{$t('simulation.product.detail.discount')}}</td>
                <td>{{ range.electricity.subtotal.discount[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin" v-for="meterType in elecMeterTypes" :key="meterType">
                <td class="grow txt-left">{{ $tc(meterType, elecMeterTypes.length) }}</td>
                <td>{{ range.electricity.energy[meterType][unitaryPriceEuro] * 100 | toCurrency }}</td>
                <td>{{ range.electricity.energy[meterType][priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin">
                <td class="grow txt-left">{{$t('simulation.product.detail.ecoTaxes')}}</td>
                <td>{{ range.electricity.subtotal.renewable[unitaryPriceEuro] *100 | toCurrency }}</td>
                <td>{{ range.electricity.subtotal.renewable[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin total">
                <td class="grow txt-left">{{$t('simulation.product.detail.total')}}</td>
                <td></td>
                <td>{{ range.electricity.subtotal.energy[priceEuro] + range.electricity.subtotal.renewable[priceEuro] | toCurrency }}</td>
              </tr>
            </table>
          </div>
          <div class="flex"></div>
          <div class="price-details">
            <h3>{{$t('simulation.product.detail.transportTaxes')}}</h3>
            <table class="price inline">
              <tr class="inline h-item-margin">
                <td class="grow txt-left">{{$t('simulation.product.detail.taxes')}}</td>
                <td>{{ range.electricity.subtotal.taxes[priceEuro] + range.electricity.subtotal.taxesVAT[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin">
                <td class="grow txt-left">{{$t('simulation.product.detail.transport')}}</td>
                <td>{{ range.electricity.subtotal.transportAndDistribution[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin total">
                <td class="grow txt-left">{{$t('simulation.product.detail.total')}}</td>
                <td></td>
                <td>
                  {{ range.electricity.subtotal.taxes[priceEuro] +
                  range.electricity.subtotal.taxesVAT[priceEuro] +
                  range.electricity.subtotal.transportAndDistribution[priceEuro] | toCurrency }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="product" :class="$mq" v-if="hasGas">
          <div class="price-details">
            <div class="inline center">
              <SvgIcon icon="gas" class="icon" fill></SvgIcon>
              <h3>{{$t('simulation.product.detail.megaGas')}}</h3>
            </div>
            <table class="price inline">
              <tr class="inline h-item-margin">
                <th class="grow txt-left"></th>
                <th>{{$t('unity.centKWh')}}</th>
                <th>{{$t('unity.annual')}}</th>
              </tr>
              <tr class="inline">
                <td class="grow txt-left">{{$t('simulation.product.detail.subscription')}}</td>
                <td>{{ range.gas.subscription[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline" v-if="range.gas.subtotal.discount">
                <td class="grow txt-left">{{$t('simulation.product.detail.discount')}}</td>
                <td>{{ range.gas.subtotal.discount[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline">
                <td class="grow txt-left">{{$t('simulation.product.detail.consumption')}}</td>
                <td>{{ range.gas.energy.day[unitaryPriceEuro] * 100 | toCurrency }}</td>
                <td>{{ range.gas.energy.day[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin" v-if="range.options.green.length">
                <td class="grow txt-left">{{$t('simulation.product.detail.green')}}</td>
                <td></td>
                <td>
                  {{ range.gas.subtotal.energy[priceEuroEco] -
                  range.gas.subtotal.energy[priceEuro] | toCurrency }}
                </td>
              </tr>
              <tr class="inline h-item-margin total" v-if="!range.options.green.length">
                <td class="grow txt-left">{{$t('simulation.product.detail.total')}}</td>
                <td></td>
                <td>{{ range.gas.subtotal.energy[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin total" v-if="range.options.green.length">
                <td class="grow txt-left">{{$t('simulation.product.detail.total')}}</td>
                <td></td>
                <td>{{ range.gas.subtotal.energy[priceEuroEco] | toCurrency }}</td>
              </tr>
            </table>
          </div>
          <div class="flex"></div>
          <div class="price-details">
            <h3>{{$t('simulation.product.detail.transportTaxes')}}</h3>
            <table class="price inline">
              <tr class="inline">
                <td class="grow txt-left">{{$t('simulation.product.detail.taxes')}}</td>
                <td>{{ range.gas.subtotal.taxes[priceEuro] + range.gas.subtotal.taxesVAT[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin">
                <td class="grow txt-left">{{$t('simulation.product.detail.transport')}}</td>
                <td>{{ range.gas.subtotal.transportAndDistribution[priceEuro] | toCurrency }}</td>
              </tr>
              <tr class="inline h-item-margin total">
                <td class="grow txt-left">{{$t('simulation.product.detail.total')}}</td>
                <td></td>
                <td>
                  {{ range.gas.subtotal.taxes[priceEuro] +
                  range.gas.subtotal.taxesVAT[priceEuro] +
                  range.gas.subtotal.transportAndDistribution[priceEuro] | toCurrency }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="become">
        <a :href="become" class="button">{{$t('become')}}</a>
      </div>
      <div class="condition inline space-around">
        <a target="_blank" :href="generalCondition">{{ $t('generalCondition') }}</a>
        <a target="_blank" :href="pricing">{{ $t('pricing') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: {
    range: {
      type: Object
    }
  },
  computed: {
    ...mapState("contact", ["isPro"]),
    ...mapGetters("consumption", ["elecMeterTypes"]),
    hasElec() {
      return this.range.electricity !== undefined;
    },
    hasGas() {
      return this.range.gas !== undefined;
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    priceEuroEco() {
      return this.isPro ? "priceEuroEco" : "priceEuroVATEco";
    },
    priceEuro() {
      return this.isPro ? "priceEuro" : "priceEuroVAT";
    },
    unitaryPriceEuro() {
      return this.isPro ? "unitaryPriceEuro" : "unitaryPriceEuroVAT";
    },
    annualAmount() {
      return this.isPro ? "annualAmount" : "annualAmountVAT";
    },
    monthlyAmount() {
      return this.isPro ? "monthlyAmount" : "monthlyAmountVAT";
    },
    generalCondition() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/conditions-generales-de-vente"
        : "https://www.mega.be/nl/algemene-voorwaarden";
    },
    pricing() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/electricite-et-gaz/tarif-gaz-electricite"
        : "https://www.mega.be/nl/elektriciteit-en-aardgas";
    },
    become() {
      return this.$store.getters["middleware/become"](this.range);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  filters: {
    toCurrency: function(value) {
      return value.toFixed(2).replace(".", ",");
    }
  },
  created() {
    console.log(this.range);
    let body = document.body;
    body.classList.add("modal-open");
  },
  destroyed() {
    let body = document.body;
    body.classList.remove("modal-open");
  }
};
</script>

<style lang="scss" scoped>
#details {
  position: fixed;
  overflow: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.mobile {
    padding-top: 170px;
    position: fixed;
  }

  .modal {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 20px;
    border-top: 15px solid #fdcb47;
    border-radius: 30px;
    margin: 0 20%;
    margin-bottom: 20px;
    background: white;

    &.mobile {
      position: absolute;
      border-radius: 0;
      top: 0px;
      margin: 0;

      .close {
        top: 20px;
        right: 20px;
      }
    }

    .close {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
      position: absolute;
      top: -20px;
      right: 0px;
      background: black;
      border: 2px solid #fdcb47;
      color: #fdcb47;
      height: 25px;
      width: 25px;
      border-radius: 50%;
    }

    .title {
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 2rem;
      font-weight: 700;

      .icon {
        color: #fdcb47;
        font-size: 3rem;
      }
    }

    .price {
      background: #fdcb47;
      color: #231f20;
      font-size: 0.6rem;
      padding: 10px 0;

      .amount {
        font-size: 1.8rem;
        font-weight: 500;

        &.second {
          font-size: 1.2rem;
          font-weight: normal;
        }
      }
    }

    .product {
      min-width: 270px;

      &.mobile {
        min-width: 100%;
      }

      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 450px;

      .flex {
        flex: 1;
      }

      .icon {
        font-size: 2rem;
        color: #fdcb47;
      }

      .price-details {
        margin: 10px;
        margin-bottom: 20px;
        h3 {
          margin: 5px;
          font-size: 1.2rem;
        }

        table.price {
          width: 100%;
          font-size: 0.8rem;
          background: none;
          border-collapse: collapse;

          tr {
            width: 100%;
            &:nth-child(odd) {
              background: #f2f2f2;
            }
            &:nth-child(even) {
              background: white;
            }
            &.total {
              background: #e2e2e2;
            }

            th {
              padding: 7px 10px;
            }
            td {
              &.grow {
                text-align: left;
              }
              text-align: right;
              min-width: 35px;
              padding: 7px 10px;
            }
          }
        }
      }
    }
  }

  .become {
    margin: 30px;

    .button {
      font-weight: 600;
      margin: 0;
      margin-bottom: 20px;
      padding: 10px 20px;
      font-size: 1.3rem;
      border: 0;
      background: #fdcb47;
      border-radius: 50px;
      box-shadow: 3px 6px 8px #fdcb475e;
    }
  }
  .condition {
    padding: 10px 0;
    border-top: 1px solid #e2e2e2;
    a {
      min-width: 200px;
      text-decoration: none;
      font-size: 0.8rem;
      color: #ccc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/simulation/Details.vue